"use client";

import { Slider } from "@ui/slider";
import { type ComponentProps } from "react";
import { useExponentialRange } from "../hooks/useExponentialRange";

export default function ExponentialRangeSlider({
  min,
  max,
  value,
  onChange,
  formatter = (value: number) => value.toString(),
}: Omit<ComponentProps<typeof Slider>, "onChange"> & {
  onChange: (values: number[]) => void;
  formatter?: (value: number) => string;
}) {
  const { config, internalValues, onChangeValue } = useExponentialRange({
    min,
    max,
    value,
  });

  function handleChangeValue(values: number[]) {
    onChange(values.map(config.toExternal));
  }

  return (
    <>
      <div className="flex justify-between pb-4">
        {internalValues?.map((internalValue, index) => (
          <span key={internalValue + index}>
            {formatter(Math.ceil(config.toExternal(internalValue)))}
          </span>
        ))}
      </div>
      <Slider
        min={config.min}
        max={config.max}
        value={internalValues}
        onValueChange={onChangeValue}
        onValueCommit={handleChangeValue}
        minStepsBetweenThumbs={1}
      />
    </>
  );
}
